module.exports = __webpack_public_path__ + "static/media/undraw-having-fun-iais.69f083cb.png";